import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/about/page.tsx");
